import { fromSpecific } from '@rehaje/core'
import { reactive, toJS } from '@rehaje/reactive'

import { SchemaNode } from './SchemaNode'

export class ValuableNode extends SchemaNode {
  /**
   * 表单默认值
   */
  @fromSpecific()
  @reactive()
  initialValue?: any

  /**
   * 表单值
   */
  @fromSpecific()
  @reactive()
  value?: any

  constructor(specific: any) {
    super({
      ...specific,
      initialValue: toJS(specific.initialValue)
    })
  }
}

declare global {
  export interface RehajeSchemaMetadata {
    /**
     * 表单、字段默认值
     * 1. 可作为初始化回显入口
     * 2. 强制序列化回显，也就是回显前会先做一次 toJS，防止与保证数据纯粹性
     * 3. 支持建模编译(可配置表达式进行默认值联动)
     * 4. 重置时可回退为该默认值
     */
    initialValue?: any
    /**
     * 表单、字段值
     * 1. 可作为初始化回显入口
     * 2. 非序列化回显，一般用于传入一棵已存在的 TypedNode 树，或者序列化 TypedSpecific 结构，保证不会与表单发生冲突
     * 3. 不支持建模编译(也就是无法配置表达式)
     * 4. 初始配置无法作为重置回退值
     * 5. 优先级比 initialValue 高，配置之后, initialValue 将不会生效
     */
    value?: any
  }
}
